<div class="smallscreen-page">
    <div class="smallscreen-container">
        <img src="assets/img/vx-management-logo.png" class="smallscreen-domain-logo">
        <div class="smallscreen-text">Content available only for large screen sizes.</div>  
        <div class="smallscreen-subtext">Please try again from another device.</div>  
    </div>
</div>
